import { configureStore } from '@reduxjs/toolkit';

import { additionalPageContentApi } from '@helsenorge/framework-utils/additional-page-content';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';

import contentApi from './contentApi';
import rootReducer from './reducer';
import tilesApi from './tilesApi';
import { resourcesApi } from '../resources';

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(contentApi.middleware)
      .concat(tilesApi.middleware)
      .concat(tjenesteTeksterApi.middleware)
      .concat(resourcesApi.middleware)
      .concat(additionalPageContentApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
